<template>
  <div>
    <template v-for="menu in navMenus">
      <el-menu-item
        v-if="!menu.menus"
        :index="'/' + menu.url"
        :key="menu.menuid"
      >
        <i class="iconfont" :class="menu.icon"></i>
        <span slot="title">{{ menu.menuname }}</span>
      </el-menu-item>

      <el-submenu v-if="menu.menus" :index="'/' + menu.url" :key="menu.menuid">
        <template slot="title">
          <i class="iconfont" :class="menu.icon"></i>
          <span slot="title">{{ menu.menuname }}</span>
        </template>
        <NavMenu :navMenus="menu.menus"></NavMenu>
      </el-submenu>
    </template>

    
  </div>
</template>

<script>
export default {
  name: "NavMenu",
  props: ["navMenus"],
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>
<style scoped lang="less">
.el-menu-item {
  background: #094b88;
}
.el-submenu {
  background: #094b88;
}
</style>



// WEBPACK FOOTER //
// src/components/NavMenu.vue